import api from "./api";
import consts, { mapKeys } from "./consts";
import languages from "./languages/languages.json";
import { get, post, put, del } from "./api/request";

const locale = "pt-br"

const lang = languages[locale]

let branch_owner = window.localStorage.getItem(consts.CURRENT_BRANCH)
let allBranches = window.localStorage.getItem(consts.ALL_BRANCHES)
let user = window.localStorage.getItem(consts.USER_DATA)
let plans = window.localStorage.getItem(consts.PLANS)
let certificates = window.localStorage.getItem(consts.CERTIFICATES)

function getBranchOwner() {
  if (branch_owner) {
    return JSON.parse(branch_owner)
  }
}

function getAllBranches() {
  if (allBranches) {
    return JSON.parse(allBranches)
  }
  return [] 
}

function getUser() {
  if (user) {
    return JSON.parse(user)
  }
}

function getPlan() {
  if (plans) {
    return JSON.parse(plans)[0]
  }
}

function getCertificates() {
  if (certificates) {
    let json = JSON.parse(certificates)  
    return json.reverse()
  }
}

export function getFormatedDate(date) {
  if (date) {
    date = new Date(date)
  } else {
    date = new Date()
  }

  const dateObject = {
    LongMonth: new Date(date).toLocaleString(locale, {
      "month": "long"
    }),
    LongWeekday: new Date(date).toLocaleString(locale, {
      "weekday": "long"
    })
  }
  return dateObject
}

const config = {
  api,
  consts,
  mapKeys, 
  get,
  post,
  put,
  del,
  getBranchOwner,
  getAllBranches,
  getUser,
  getPlan,
  getCertificates,
};

export { 
  api, 
  consts,
  get, 
  post, 
  put, 
  del, 
  getBranchOwner, 
  getUser, 
  getPlan, 
  getCertificates, 
  getAllBranches,
  mapKeys 
};
export default config;



// WEBPACK FOOTER //
// ./src/sources/config.jsx